<template>
  <div class="text-center my-2">
    <b-spinner :small="small" class="align-middle mr-2"></b-spinner>
    <strong>{{text}}</strong>
  </div>
</template>

<script>

export default {
  name: 'waiting-form',

  props: {
    text: {
      typeof: String,
      default: 'Загрузка данных...'
    },
    
    small: {
      typeof: Boolean,
      default: false
    }
  }
}
</script>
